import {FC} from 'react';
import clsx from 'clsx';

import {useSelector} from '~/store/hooks';

import {FooterLogo} from '../../FooterLogo/FooterLogo';
import {FooterCopyright} from '../../FooterCopyright/FooterCopyright';
import s from '../styles.module.scss';

export const FooterDesktop: FC = () => {
  const instanceLabel = useSelector(({app}) => app.data.instanceInfo.label);

  return (
    <div className={s.footer}>
      <div className={clsx(s.footer__section, s['footer__section--main'])}>
        <FooterLogo className={s.footer__logo} />

        <div className={s.footer__side}>
          <FooterCopyright instanceLabel={instanceLabel} />
        </div>
      </div>
    </div>
  );
};
